import Pages from './pages/pages';
import FormPage, { ComponentWithForm as ComponentWithFormType } from './form-page/form-page';
import SideMenuContainer from './side-menu-container/side-menu-container';

export { Pages, FormPage, SideMenuContainer };
export type ComponentWithForm<T> = ComponentWithFormType<T>;
